<ng-container *ngIf="spinner">
    <div class="overlay"></div>
    <mat-spinner></mat-spinner>
</ng-container>
<router-outlet *ngIf="!authService.isIframe"></router-outlet>
